import axios from "axios";

export const BACKEND_URL = process.env.REACT_APP_BACKEND_URL || "";
export const API = `${BACKEND_URL}/api`;

export const api = axios.create({
  baseURL: API,
  withCredentials: true,
});

export const resolveImg = (v) => {
  if (!v) return "";
  if (v.startsWith("http://") || v.startsWith("https://")) return v;
  if (v.startsWith("/api/")) return `${BACKEND_URL}${v}`;
  return v;
};

export const CATEGORY_COLORS = {
  politics: "#7C3AED",
  business: "#2563EB",
  sports: "#16A34A",
  entertainment: "#EC4899",
  bangladesh: "#F59E0B",
  world: "#14B8A6",
  tech: "#0EA5E9",
};

export const timeAgo = (iso) => {
  if (!iso) return "";
  const d = new Date(iso);
  const sec = Math.floor((Date.now() - d.getTime()) / 1000);
  if (sec < 60) return `${sec}s ago`;
  const m = Math.floor(sec / 60); if (m < 60) return `${m} min ago`;
  const h = Math.floor(m / 60); if (h < 24) return `${h}h ago`;
  const dd = Math.floor(h / 24); if (dd < 7) return `${dd}d ago`;
  return d.toLocaleDateString();
};

export const fullDate = (iso) => iso ? new Date(iso).toLocaleString("en-GB", { timeZone: "Asia/Dhaka" }) + " BDT" : "";
